import { fetchHandler } from "../Handler/Handler";


export const FetchProfile = async (slugname) => {
  try {
    const response = await fetchHandler({
      method: "GET",
      endpoint: `/vendor/${slugname}/me`,
      data: null,
    });
    return response;
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};
